module.exports = __webpack_public_path__ + "img/vip@2x.074ebd25.png";